import React, { useEffect } from 'react';

const TermsPage = () => {
  return (
    <>
      

      <div className="min-h-screen bg-gradient-to-br from-black via-black to-black md:p-8 pt-16  ">
        <div className="max-w-4xl mx-auto pt-16">
          <div className="backdrop-blur-lg bg-black rounded-xl p-6 md:p-8 shadow-2xl border border-emerald-500/20">
            {/* Terms and Conditions Section */}
            <section>
              <h1 className="text-4xl md:text-5xl font-bold text-white mb-4 bg-gradient-to-r from-emerald-400 to-emerald-300 bg-clip-text text-transparent">
                Terms and conditions
              </h1>
              <p className="text-emerald-400 mb-8">Last updated January 12, 2025</p>
            </section>

            <section>
              <h2 className="text-2xl md:text-3xl font-semibold text-white mb-6">
                Agreement to our legal terms
              </h2>

              <div className="space-y-6 text-gray-300">
                <p>
                  Welcome to Example Company ('Company', 'we', 'us', or 'our'), a company registered at 123 Business
                  Avenue. Our registration number is 12345678.
                </p>

                <p>
                  We operate the website example.com (the 'Site'), as well as any other related products and services
                  that refer or link to these legal terms (the 'Legal Terms') (collectively, the 'Services').
                </p>

                <div className="bg-gray-900/50 p-6 rounded-lg border border-emerald-500/20">
                  <p className="text-emerald-400 font-bold mb-4">Important Notice:</p>
                  <p className="text-white">
                    By accessing or using the Services, you agree that you have read, understood, and agreed to be bound
                    by all of these Legal Terms. If you do not agree with all of these Legal Terms, you are expressly
                    prohibited from using the Services and must discontinue use immediately.
                  </p>
                </div>

                <p>
                  These Legal Terms constitute a legally binding agreement made between you, whether personally or on
                  behalf of an entity ('you'), and Example Company, concerning your access to and use of the Services.
                </p>

                <div className="bg-gray-900/50 p-6 rounded-lg border border-emerald-500/20">
                  <p className="text-emerald-400 font-bold mb-4">Important Notice:</p>
                  <p className="text-white">
                    By accessing or using the Services, you agree that you have read, understood, and agreed to be bound
                    by all of these Legal Terms. If you do not agree with all of these Legal Terms, you are expressly
                    prohibited from using the Services and must discontinue use immediately.
                  </p>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </>
  );
};

export default TermsPage;
